import { makeOptionsData } from 'Common/FormHelper';
import * as types from './types';

const INITIAL_STATE = {
  error: null,
  loading: false,
  allergens: [],
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.RECIPE_LISTING_GET_ALLERGENS:
      return {
        ...state,
        allergens: makeOptionsData(payload),
      };
    case types.RECIPE_LISTING_GET_ALLERGENS_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.RECIPE_LISTING_LOADING:
      return { ...state, loading: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/recipelisting/state/report/reducer.js